<template>
    <div class="view offer-single">
    <Modal
      v-if="showModal"
      type="error"
      v-on:closeModal="hideModal"
      />
    <h3 class="section-title">{{title}}</h3>
    <FormCard class="form-content"
      @showModal="showModal=true"
      @submitOffer="submitOffer"
      />
    <PreOfferCard class="preview-content" />
    </div>
</template>

<script>
import FormCard from '@/components/cards/FormCard'
import PreOfferCard from '@/components/cards/PreOfferCard'
import Modal from '@/components/modals/Modal'

import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'content-single',
    components: {
        Modal,
        FormCard,
        PreOfferCard
    },
    data: function(){
        return {
            showModal: false,
            title: '',
            edit: false,
        }
    },
    created: function(){
      this.$store.dispatch("auth/setActive", "content");
      if (this.$route.name == "new_content") {
        this.title = 'Crear contenido'
        this.setEmptyDummyOffer()
        // this.edit = false
      } else if (this.$route.name == "content_detail") {
        this.title = 'Editar contenido'
        this.setSelectedOffer(this.getOffer(this.$route.params.id)[0])
        // this.edit = true
      }
    },
    computed: {
      ...mapGetters('offers', [
        'getOffer'
      ])
    },
    methods: {
        submitOffer: function(offer){
          if (this.$route.name == "new_content") {
            this.addOffer(offer.form)
              .then(r => {
                  this.setEmptyDummyOffer()
                  var r = JSON.parse(r)
                  this.$router.push({path:'/ofertas/gestion/'+r.id})
              }, err => {
                  this.$emit('showModal')
              })
          } else {
            this.updateOffer(offer)
              .then(r => {
                  this.setEmptyDummyOffer()
                  var r = JSON.parse(r)
                  this.$router.push({path:'/ofertas/gestion'})
              }, err => {
                  this.$emit('showModal')
              })
          }
        },
        ...mapActions('offers', [
          'setEmptyDummyOffer',
          'setSelectedOffer',
          'addOffer',
          'updateOffer'
        ])
    }
}
</script>

<style lang="sass">
.view.offer-single
  margin-top: $xl
  grid-template-columns: 80px repeat(10, minmax(0, 1fr)) 66px
  @include tablet-landscape
    grid-template-columns: 4px repeat(10, minmax(0, 1fr)) 4px
  @include tablet-portrait
    grid-template-columns: 4px repeat(10,minmax(0, 1fr)) 4px
  .form-content
    grid-column-start: 2
    grid-column-end: 9
    @include tablet-landscape
      grid-column: 2/8
    @include tablet-portrait
      grid-column: 2/7
  .preview-content
    grid-column-start: 9
    grid-column-end: 12
    @include tablet-landscape
      grid-column: 8/12
    @include tablet-portrait
      grid-column: 7/12

.section-title
  grid-column-start: 2
  grid-column-end: 8
  font-family: Montserrat
  font-size: 24px
  color: #ffffff
  width: 80%
.view.offer-single .section-title
  margin-bottom: $md

</style>